export const environment = {
  production: true,
  designMode: false
};